module.exports = new __parcel__URL__("project-img1.c7006de8.png").toString();